import React from 'react';
import Button from '../../../../../components/Button';
import FixedBottomNavBar from '../../../../../components/FixedBottomNavBar';
import { RECOMMEND_REVIEW_COPY_URL_PATH } from '../../../../../constants/service/common/urlConstants';
import { reDirectPage, setDetailPageUrl } from '../../../../../lib/common';
import './RecommendReviewDetailNavbar.scss';

const RecommendReviewDetailNavbar = (props) => {
  const { recommendReviewId } = props;

  return (
    <FixedBottomNavBar className="recommend-review-detail-navbar">
      <div className="button-group">
        <Button
          color="primary"
          text="복사하기"
          onClick={() => reDirectPage({ path: setDetailPageUrl(RECOMMEND_REVIEW_COPY_URL_PATH, recommendReviewId) })}
        />
      </div>
    </FixedBottomNavBar>
  );
};

export default RecommendReviewDetailNavbar;
